import { computed, reactive } from 'vue';
import { Address } from '../../../types';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '../i18n/i18n-validators';
import { useCountryStore } from '../stores/countryStore';

export const NAME = 'address';

export function useAddressSetup(address: Address | undefined) {
    const countryStore = useCountryStore();
    const fields = reactive({
        id: address?.id || '',
        street: address?.street || '',
        number: address?.number || '',
        additional: address?.additional || '',
        zip: address?.zip || '',
        city: address?.city || '',
        country_code: address?.country?.code || '',
    });

    const isDach = computed(() => {
        const country = countryStore.getCountryByCode(fields?.country_code);
        return country?.is_dach;
    });

    const i18nCodePrefix = computed(() =>
        isDach.value ? 'forms.addressDach' : 'forms.addressNonDach'
    );

    const rules = computed(() => ({
        street: { required },
        number: { required: requiredIf(isDach.value || false) },
        zip: { required: requiredIf(isDach.value || false) },
        city: { required },
        country_code: { required },
    }));

    const v$ = useVuelidate(rules, fields);

    return { fields, isDach, rules, i18nCodePrefix, v$ };
}
